<template>  
  <div class="relative app-page-container">
    <slot name="page-content"></slot>
  </div>
</template>

<script>
  import { bus } from '../../assets/js/src/main'
  export default {
    components: {
      //
    },
    props: {
      //headerSpacerIsReduced
    }, 
    data () {
      return {
        //
      }
    },
    computed: {
      //
    },
    methods: {
      //
    },
    created () {
      bus.$on('messageBarClosed', () => {
        console.log('messageBarClosed: ');
        this.headerSpacerIsReduced = true;
      })
    },
    mounted () {
      //
    },
    watch: {
      /*
      $route (to, from) {
        //
      }
      */
    },
    beforeDestroy() {
      //
    },
    updated() {
      //
    }
  }
</script>